import { Card, CardBody, Col } from "reactstrap";
import ReactApexChart from "react-apexcharts";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { SkillStatusTitle } from "../../../../Constants/Constants";
import { SkillChart } from "../../../../Data/General/Widgets/Chart";

const SkillStatus = () => {
  return (
    <Col xl="6" lg="12" className="box-col-6 xl-50">
      <Card>
      <CommonCardHeader title={SkillStatusTitle}/>
        <CardBody>
          <div className="chart-container skill-chart">
            <ReactApexChart id="circlechart" options={SkillChart} series={SkillChart.series} type="radialBar"height={350}/>
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default SkillStatus;
